'use-strict';

import React from 'react'
import NavItemScroll from './NavItemScroll.jsx';
import {Navbar, Nav, NavItem} from 'react-bootstrap';
// import Mailto from 'react-mailto'

// export const Mail = () => <Mailto email="j@sonbellamy.com" obfuscate={true}>
//         Email me!
//       </Mailto>;

const navigationItem = {
  navBarStyle: {
    color: 'red',
    backgroundColor: '#00cd96'
  },
  brandStyle: {
    color: 'white',
    fontSize: '2em',
    marginTop: '0px'
  }
};

class Navigation extends React.Component {



  constructor(props, context) {
    super(props, context);

    this.handleToggle = this.handleToggle.bind(this);
    this.handleCollapse = this.handleCollapse.bind(this);
  }

  handleCollapse() {
    const { onToggle, expanded } = this.props;

    if (expanded) {
      onToggle(false);
    }
  }

  handleToggle() {
    console.log("fuck");
    const { onToggle, expanded } = this.props;

    onToggle(!expanded);
  }

  render() {
    return (<Navbar inverse fixedTop style={navigationItem.navBarStyle} >
      <Navbar.Header>
        <Navbar.Toggle/>
      </Navbar.Header>
        <Navbar.Collapse>
        <Nav pullLeft onSelect={this.handleCollapse}>
          <NavItemScroll eventKey={1}  id='about' name='About'></NavItemScroll>
          <NavItemScroll eventKey={2} id='location' name='Location'></NavItemScroll>
          <NavItemScroll eventKey={3} id='gallery' name='Gallery'></NavItemScroll>
          {/* <NavItemScroll eventKey={4} id='contact' name='Contact'></NavItemScroll> */}
        </Nav>
        <Nav pullRight>
          <NavItem eventKey={5} href='https://www.facebook.com/kakkaradentalcare/' target='_blank' alt='Facebook'>
            <span className='fa fa-facebook'></span>
          </NavItem>
          <NavItem eventKey={7} href='mailto:kakkaradentalclinic@gmail.com?Subject=Hello%20Doctor' target='_top' alt='Mail'>
            <span className='fa fa-envelope'></span>
          </NavItem>
          {/* <NavItem eventKey={7} href='https://twitter.com/jareddonisvitch' target='_blank' alt='Twitter'>
            <span className='fa fa-twitter'></span>
          </NavItem> */}
        </Nav>
      </Navbar.Collapse>
    </Navbar>);
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/Navigation/Navigation.jsx